import * as angular from "angular";

angular
  .module('bringoz.admin.labels')
  .config(labelsConfig);

/* @ngInject */
function labelsConfig($stateProvider) {

  $stateProvider

    // Labels
    .state('labels', {
      parent: 'bringoz.site',
      url: '/labels',
      template: '<labels-view labels="vm.labels"></labels-view>',
      controllerAs: 'vm',
      controller: function($scope, triBreadcrumbsService, labels, site) {

        this.labels = labels;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Labels"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        labels: function(site, labelsRequestsService) {
          return labelsRequestsService.getAll();
        }
      }
    });

}
